module.exports = __webpack_public_path__ + "img/2023-02.40baef0b.jpg";